import { MapPin } from "lucide-react";

const serviceAreas = [
  {
    region: "Southern New Hampshire",
    cities: ["Londonderry (HQ)", "Manchester", "Nashua", "Derry", "Salem", "Portsmouth", "Hampton", "Exeter", "Bedford", "Merrimack"],
  },
  {
    region: "Northeast Massachusetts",
    cities: ["Lowell", "Lawrence", "Haverhill", "Andover", "Methuen", "Newburyport", "Gloucester", "Salem", "Peabody", "Lynn"],
  },
];

export default function ServiceAreaSection() {
  return (
    <section id="service-area" className="py-24 bg-[#141414]" data-testid="service-area-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="overline mb-4" data-testid="service-area-overline">Service Coverage</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white mb-4" data-testid="service-area-heading">
            Proudly Servicing <span className="gold-text">New Hampshire, Northern Massachusetts & Southern Maine</span>
          </h2>
          <p className="text-[#A1A1AA] max-w-2xl mx-auto text-lg">
            From our home base in Londonderry NH, we provide reliable draft beer services 
            across New Hampshire, Northern Massachusetts and Southern Maine.
          </p>
        </div>

        {/* Coverage Stats */}
        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-3 gap-4">
            <div className="text-center p-4 bg-[#1A1A1A] border border-[#27272A] rounded-xl">
              <p className="font-heading text-2xl text-[#D4AF37]">50+</p>
              <p className="text-[#A1A1AA] text-xs">Miles Radius</p>
            </div>
            <div className="text-center p-4 bg-[#1A1A1A] border border-[#27272A] rounded-xl">
              <p className="font-heading text-2xl text-[#D4AF37]">3</p>
              <p className="text-[#A1A1AA] text-xs">States Covered</p>
            </div>
            <div className="text-center p-4 bg-[#1A1A1A] border border-[#27272A] rounded-xl">
              <p className="font-heading text-2xl text-[#D4AF37]">100+</p>
              <p className="text-[#A1A1AA] text-xs">Zip Codes</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
